import { createReducer, on } from "@ngrx/store";
import { paymentMachineActions } from "./payment-machine.actions";

export interface IPaymentMachineState {
    lista: any[];
    isLoading: boolean
}

const initialState: IPaymentMachineState = {
    lista: [],
    isLoading: false
}

export const paymentMachineReducer = createReducer(
    initialState,
    on(paymentMachineActions.loadPaymentMachine, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        paymentMachineActions.loadPaymentMachineSuccess,
        (state, { lista }) => ({
            ...state,
            lista: [...lista],
            isLoading: false
        })

    )

    // on(paymentMachineActions.savePaymentMachineSuccess, (state, { machine }) => ({
    //     ...state,
    //     lista: [...state.lista, machine],
    // }))
)